export default Object.freeze([
    '#efcdff', '#dc99ff', '#c367ff', '#aa3fff', '#8400ff', '#6400db', '#4b01b9', '#340095', '#24007b',
    '#e4fcda', '#c7f8b4', '#9fec8c', '#77d86c', '#43bf3f', '#2da435', '#1d8a2e', '#136e28', '#0b5b25',
    '#d1f6fe', '#a4e6fe', '#77d2fc', '#55bdfb', '#1e9bf7', '#1578d3', '#0e5ab1', '#083f8f', '#052c76',
    '#fdf5cc', '#fee998', '#fedb67', '#fdcc3f', '#ffb200', '#d99301', '#b67501', '#915901', '#794700',
    '#fdd4d9', '#fdabb9', '#fd80a2', '#fd609c', '#fe2c91', '#d9208d', '#b51684', '#910e77', '#78086c',
    '#fde5d8', '#fec5b1', '#fd9f8a', '#fe7a6d', '#fd3e3b', '#d92c37', '#b51e36', '#911232', '#790b2f',
    '#fdeccd', '#fdd599', '#fdb666', '#fe9940', '#fd6801', '#da4c01', '#b53400', '#912100', '#791401',
    '#ffffff', '#E6E6E6', '#CDCDCD', '#B4B4B4', '#9B9B9B', '#828282', '#696969', '#373737', '#000000',
]);
